import moment from "moment";
import React, { Component, Fragment } from "react";
import { Col, Row, Card, CardBody, Label } from "reactstrap";

class EventDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: props.event,
      SPIEvent: props.SPIEvent,
    };
  }
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <Row>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">Starting Date</Label>
                  <p>
                    {moment
                      .utc(this.state.event.startingAt)
                      .format("MM-DD-YYYY")}
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">Ending Date</Label>
                  <p>
                    {this.state.event.endingAt
                      ? moment
                          .utc(this.state.event.endingAt)
                          .format("MM-DD-YYYY")
                      : "-"}
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">Status</Label>
                  <p>
                    {this.state.event.subscriptionsExpiredAt
                      ? "InActive"
                      : "Active"}
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">
                    {this.state.SPIEvent ? "Registrations" : "Registered"}
                  </Label>
                  <p>{this.state.event.registrations}</p>
                </div>
              </Col>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">Price</Label>
                  <p>{parseFloat(this.state.event.price).toFixed(2)}</p>
                </div>
              </Col>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">Invoiced</Label>
                  <p>{parseFloat(this.state.event.invoiced).toFixed(2)}</p>
                </div>
              </Col>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">Paid</Label>
                  <p>{parseFloat(this.state.event.paid).toFixed(2)}</p>
                </div>
              </Col>
              <Col sm={3}>
                <div>
                  <Label className="text-primary">Outstanding</Label>
                  <p>{parseFloat(this.state.event.pending).toFixed(2)}</p>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}

export default EventDetails;
